module.exports = __webpack_public_path__ + "static/media/r16.7d40d9c6.jpg";